export { default as ConsentDeclinePrDialog } from './ConsentDeclinePrDialog';
